import { Check } from './check.class';
import { merge } from 'lodash';

export class CheckDesurging extends Check {
  data: {
    pressionBefore?: number;
    pressionAfter?: number;
    comments?: string;
  };

  constructor(obj?: any) {
    super(CheckDesurging.type);

    if(!obj) obj = {};

    this.data = merge({

      },
      obj.data
    );
  }

  public static type = 'desurging';
  public static label = 'Ballons Anti-bélier';
}



// WEBPACK FOOTER //
// ./src/app/models/check/check-desurging.class.ts